// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupCompleteRouteImport } from './routes/setup-complete'
import { Route as SentryExamplePageRouteImport } from './routes/sentry-example-page'
import { Route as SchedulesRouteImport } from './routes/schedules'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterPromoRouteImport } from './routes/register-promo'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CompleteAccountRouteImport } from './routes/complete-account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StudentsIndexRouteImport } from './routes/students.index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as RulesIndexRouteImport } from './routes/rules.index'
import { Route as DevicesIndexRouteImport } from './routes/devices.index'
import { Route as StudentsIdRouteImport } from './routes/students.$id'
import { Route as SettingsHelperAppRouteImport } from './routes/settings.helper-app'
import { Route as SchoolSchoolIdRouteImport } from './routes/school.$schoolId'
import { Route as RulesNewRouteImport } from './routes/rules.new'
import { Route as RulesIdRouteImport } from './routes/rules.$id'
import { Route as DevicesAddRouteImport } from './routes/devices.add'
import { Route as DevicesIdRouteImport } from './routes/devices.$id'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as ApiSentryExampleApiRouteImport } from './routes/api.sentry-example-api'
import { Route as ApiHealthRouteImport } from './routes/api.health'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminSchoolsRouteImport } from './routes/admin.schools'
import { Route as AdminPromoCodesRouteImport } from './routes/admin.promo-codes'
import { Route as AdminMetricsRouteImport } from './routes/admin.metrics'
import { Route as AdminAuditLogsRouteImport } from './routes/admin.audit-logs'
import { Route as ApiAuthCallbackRouteImport } from './routes/api.auth.callback'
import { Route as SchoolSchoolIdIndexRouteImport } from './routes/school.$schoolId.index'
import { Route as SchoolSchoolIdStudentsRouteImport } from './routes/school.$schoolId.students'
import { Route as SchoolSchoolIdStaffRouteImport } from './routes/school.$schoolId.staff'
import { Route as SchoolSchoolIdSetupRouteImport } from './routes/school.$schoolId.setup'
import { Route as SchoolSchoolIdSettingsRouteImport } from './routes/school.$schoolId.settings'
import { Route as SchoolSchoolIdSchedulesRouteImport } from './routes/school.$schoolId.schedules'
import { Route as SchoolSchoolIdGroupsRouteImport } from './routes/school.$schoolId.groups'
import { Route as SchoolSchoolIdDevicesRouteImport } from './routes/school.$schoolId.devices'
import { Route as SchoolSchoolIdBillingRouteImport } from './routes/school.$schoolId.billing'
import { Route as AdminRulesIndexRouteImport } from './routes/admin.rules.index'
import { Route as AdminRulesIdRouteImport } from './routes/admin.rules.$id'
import { Route as AdminSchoolsIndexRouteImport } from './routes/admin.schools.index'
import { Route as AdminSchoolsIdRouteImport } from './routes/admin.schools.$id'
import { Route as SchoolSchoolIdRulesIndexRouteImport } from './routes/school.$schoolId.rules.index'
import { Route as SchoolSchoolIdRulesNewRouteImport } from './routes/school.$schoolId.rules.new'
import { Route as SchoolSchoolIdRulesPolicyIdRouteImport } from './routes/school.$schoolId.rules.$policyId'

const SetupCompleteRoute = SetupCompleteRouteImport.update({
            id: '/setup-complete',path: '/setup-complete',getParentRoute: () => rootRouteImport
          })
const SentryExamplePageRoute = SentryExamplePageRouteImport.update({
            id: '/sentry-example-page',path: '/sentry-example-page',getParentRoute: () => rootRouteImport
          })
const SchedulesRoute = SchedulesRouteImport.update({
            id: '/schedules',path: '/schedules',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RegisterPromoRoute = RegisterPromoRouteImport.update({
            id: '/register-promo',path: '/register-promo',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const CompleteAccountRoute = CompleteAccountRouteImport.update({
            id: '/complete-account',path: '/complete-account',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const StudentsIndexRoute = StudentsIndexRouteImport.update({
            id: '/students/',path: '/students/',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => rootRouteImport
          })
const RulesIndexRoute = RulesIndexRouteImport.update({
            id: '/rules/',path: '/rules/',getParentRoute: () => rootRouteImport
          })
const DevicesIndexRoute = DevicesIndexRouteImport.update({
            id: '/devices/',path: '/devices/',getParentRoute: () => rootRouteImport
          })
const StudentsIdRoute = StudentsIdRouteImport.update({
            id: '/students/$id',path: '/students/$id',getParentRoute: () => rootRouteImport
          })
const SettingsHelperAppRoute = SettingsHelperAppRouteImport.update({
            id: '/settings/helper-app',path: '/settings/helper-app',getParentRoute: () => rootRouteImport
          })
const SchoolSchoolIdRoute = SchoolSchoolIdRouteImport.update({
            id: '/school/$schoolId',path: '/school/$schoolId',getParentRoute: () => rootRouteImport
          })
const RulesNewRoute = RulesNewRouteImport.update({
            id: '/rules/new',path: '/rules/new',getParentRoute: () => rootRouteImport
          })
const RulesIdRoute = RulesIdRouteImport.update({
            id: '/rules/$id',path: '/rules/$id',getParentRoute: () => rootRouteImport
          })
const DevicesAddRoute = DevicesAddRouteImport.update({
            id: '/devices/add',path: '/devices/add',getParentRoute: () => rootRouteImport
          })
const DevicesIdRoute = DevicesIdRouteImport.update({
            id: '/devices/$id',path: '/devices/$id',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const ApiSentryExampleApiRoute = ApiSentryExampleApiRouteImport.update({
            id: '/api/sentry-example-api',path: '/api/sentry-example-api',getParentRoute: () => rootRouteImport
          })
const ApiHealthRoute = ApiHealthRouteImport.update({
            id: '/api/health',path: '/api/health',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminSchoolsRoute = AdminSchoolsRouteImport.update({
            id: '/schools',path: '/schools',getParentRoute: () => AdminRoute
          })
const AdminPromoCodesRoute = AdminPromoCodesRouteImport.update({
            id: '/promo-codes',path: '/promo-codes',getParentRoute: () => AdminRoute
          })
const AdminMetricsRoute = AdminMetricsRouteImport.update({
            id: '/metrics',path: '/metrics',getParentRoute: () => AdminRoute
          })
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
            id: '/audit-logs',path: '/audit-logs',getParentRoute: () => AdminRoute
          })
const ApiAuthCallbackRoute = ApiAuthCallbackRouteImport.update({
            id: '/api/auth/callback',path: '/api/auth/callback',getParentRoute: () => rootRouteImport
          })
const SchoolSchoolIdIndexRoute = SchoolSchoolIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdStudentsRoute = SchoolSchoolIdStudentsRouteImport.update({
            id: '/students',path: '/students',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdStaffRoute = SchoolSchoolIdStaffRouteImport.update({
            id: '/staff',path: '/staff',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdSetupRoute = SchoolSchoolIdSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdSettingsRoute = SchoolSchoolIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdSchedulesRoute = SchoolSchoolIdSchedulesRouteImport.update({
            id: '/schedules',path: '/schedules',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdGroupsRoute = SchoolSchoolIdGroupsRouteImport.update({
            id: '/groups',path: '/groups',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdDevicesRoute = SchoolSchoolIdDevicesRouteImport.update({
            id: '/devices',path: '/devices',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdBillingRoute = SchoolSchoolIdBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => SchoolSchoolIdRoute
          })
const AdminRulesIndexRoute = AdminRulesIndexRouteImport.update({
            id: '/rules/',path: '/rules/',getParentRoute: () => AdminRoute
          })
const AdminRulesIdRoute = AdminRulesIdRouteImport.update({
            id: '/rules/$id',path: '/rules/$id',getParentRoute: () => AdminRoute
          })
const AdminSchoolsIndexRoute = AdminSchoolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminSchoolsRoute
          })
const AdminSchoolsIdRoute = AdminSchoolsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminSchoolsRoute
          })
const SchoolSchoolIdRulesIndexRoute = SchoolSchoolIdRulesIndexRouteImport.update({
            id: '/rules/',path: '/rules/',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdRulesNewRoute = SchoolSchoolIdRulesNewRouteImport.update({
            id: '/rules/new',path: '/rules/new',getParentRoute: () => SchoolSchoolIdRoute
          })
const SchoolSchoolIdRulesPolicyIdRoute = SchoolSchoolIdRulesPolicyIdRouteImport.update({
            id: '/rules/$policyId',path: '/rules/$policyId',getParentRoute: () => SchoolSchoolIdRoute
          })





const AdminSchoolsRouteChildren = {
  AdminSchoolsIdRoute: AdminSchoolsIdRoute,AdminSchoolsIndexRoute: AdminSchoolsIndexRoute
}

const AdminSchoolsRouteWithChildren = AdminSchoolsRoute._addFileChildren(AdminSchoolsRouteChildren)



const AdminRouteChildren = {
  AdminAuditLogsRoute: AdminAuditLogsRoute,AdminMetricsRoute: AdminMetricsRoute,AdminPromoCodesRoute: AdminPromoCodesRoute,AdminSchoolsRoute: AdminSchoolsRouteWithChildren,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute,AdminRulesIdRoute: AdminRulesIdRoute,AdminRulesIndexRoute: AdminRulesIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const SchoolSchoolIdRouteChildren = {
  SchoolSchoolIdBillingRoute: SchoolSchoolIdBillingRoute,SchoolSchoolIdDevicesRoute: SchoolSchoolIdDevicesRoute,SchoolSchoolIdGroupsRoute: SchoolSchoolIdGroupsRoute,SchoolSchoolIdSchedulesRoute: SchoolSchoolIdSchedulesRoute,SchoolSchoolIdSettingsRoute: SchoolSchoolIdSettingsRoute,SchoolSchoolIdSetupRoute: SchoolSchoolIdSetupRoute,SchoolSchoolIdStaffRoute: SchoolSchoolIdStaffRoute,SchoolSchoolIdStudentsRoute: SchoolSchoolIdStudentsRoute,SchoolSchoolIdIndexRoute: SchoolSchoolIdIndexRoute,SchoolSchoolIdRulesPolicyIdRoute: SchoolSchoolIdRulesPolicyIdRoute,SchoolSchoolIdRulesNewRoute: SchoolSchoolIdRulesNewRoute,SchoolSchoolIdRulesIndexRoute: SchoolSchoolIdRulesIndexRoute
}

const SchoolSchoolIdRouteWithChildren = SchoolSchoolIdRoute._addFileChildren(SchoolSchoolIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,CompleteAccountRoute: CompleteAccountRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,RegisterRoute: RegisterRoute,RegisterPromoRoute: RegisterPromoRoute,ResetPasswordRoute: ResetPasswordRoute,SchedulesRoute: SchedulesRoute,SentryExamplePageRoute: SentryExamplePageRoute,SetupCompleteRoute: SetupCompleteRoute,ApiHealthRoute: ApiHealthRoute,ApiSentryExampleApiRoute: ApiSentryExampleApiRoute,CheckoutSuccessRoute: CheckoutSuccessRoute,DevicesIdRoute: DevicesIdRoute,DevicesAddRoute: DevicesAddRoute,RulesIdRoute: RulesIdRoute,RulesNewRoute: RulesNewRoute,SchoolSchoolIdRoute: SchoolSchoolIdRouteWithChildren,SettingsHelperAppRoute: SettingsHelperAppRoute,StudentsIdRoute: StudentsIdRoute,DevicesIndexRoute: DevicesIndexRoute,RulesIndexRoute: RulesIndexRoute,SettingsIndexRoute: SettingsIndexRoute,StudentsIndexRoute: StudentsIndexRoute,ApiAuthCallbackRoute: ApiAuthCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)